import apiHeader from '@/helpers/apiHeader';

const characteristicService = {
  list(params) {
    return apiHeader.get('dictionary/characteristics', { params });
  },
  detail(id) {
    return apiHeader.get('dictionary/characteristics/' + id);
  },
  create(params) {
    return apiHeader.post('dictionary/characteristics', params);
  },
  update(id, params) {
    return apiHeader.put('dictionary/characteristics/' + id, params);
  },
  delete(id) {
    return apiHeader.delete('dictionary/characteristics/' + id);
  },
};

export default characteristicService;
